export class ProductAccountingDimensionsDto {
  channel: string;
  department: string;
  product: string;
  id?: string;

  constructor(d?: ProductAccountingDimensionsDto) {
    if (!d) {
      return;
    }

    Object.assign(this, d);
  }
}
